<template>
    <div component="Home" template="page" :scene="getScene">
        <div class="bg">
            <video-gallery-player />
            <container :name="'main'" :type="'horizontal'" :class="{ hasDetail: getIsDetail }">
                <div block="accordion">
                    <accordion
                        :scene="getScene"
                        @setFocus="setFocus"
                        @collapseAll="collapseAll"
                        :landscape="getIsLanscape"
                    >
                        <template #voice>
                            <AccordionItem
                                for="voice"
                                :selected="getSelected == 'voice'"
                                :scene="getScene"
                                :class="{
                                    expanded: getFocus == 'voice',
                                    collapsed: getFocus != 'voice' && getFocus != '',
                                    landscape: getIsLanscape,
                                }"
                            >
                                <template #logo>
                                    <Icon code="voice" />
                                </template>
                                <template #circles>
                                    <home-circles>
                                        <template #white
                                            ><span>{{ getAppStats.languages || '-' }}</span>
                                            <strong>LANGUAGES</strong></template
                                        >
                                        <template #red>
                                            <span>{{ getAppStats.voices || '-' }}</span>
                                            <strong>VOICES <i>&</i> FACES</strong></template
                                        >
                                        <template #grey>
                                            <span>{{ getAppStats.voice_samples || '-' }}</span>
                                            <strong>SAMPLES<br /><i>& </i>PICTURES</strong></template
                                        >
                                    </home-circles>
                                </template>
                                <template #visualizer>
                                    <nav-button
                                        v-if="!getIsDetail"
                                        :link="'/voice-database'"
                                        :text="'MORE'"
                                        :icon="'navigate_next'"
                                        tpos="left"
                                        size="big"
                                        color="ghost"
                                    />
                                    <div class="holder">
                                        <btn
                                            tpos="left"
                                            size="big"
                                            radius="circle"
                                            :icon="'camera'"
                                            @click="playFaceCination"
                                        >
                                            FACECINATION
                                        </btn>
                                        <mp3-player
                                            visualizer="voice"
                                            tpos="left"
                                            :file="$env.services.storage.baseURL + '/assets/voice-sample.mp3'"
                                            :text="'VOICE SAMPLE'"
                                            size="big"
                                        />
                                    </div>
                                    <visualizer name="voice" />
                                </template>
                                <template #bg>
                                    <div class="icon" for="voice">mic_none</div>
                                </template>
                            </AccordionItem>
                        </template>
                        <template #music>
                            <AccordionItem
                                for="music"
                                :selected="getSelected == 'music'"
                                :scene="getScene"
                                :class="{
                                    expanded: getFocus == 'music',
                                    collapsed: getFocus != 'music' && getFocus != '',
                                    landscape: getIsLanscape,
                                }"
                            >
                                <template #logo>
                                    <Icon code="music" />
                                </template>
                                <template #circles>
                                    <home-circles>
                                        <template #white>
                                            <span>{{ getAppStats.music_categories || '-' }}</span>
                                            <strong>CATEGORIES</strong></template
                                        >
                                        <template #red
                                            ><span>{{ getAppStats.music_hours || '-' }}</span>
                                            <strong>HOURS<br />TOTAL</strong></template
                                        >
                                        <template #grey>
                                            <span>{{ getAppStats.music_samples || '-' }}</span>
                                            <strong>SAMPLES</strong></template
                                        >
                                    </home-circles>
                                </template>
                                <template #visualizer>
                                    <nav-button
                                        v-if="!getIsDetail"
                                        :link="'/music-zone'"
                                        :text="'MORE'"
                                        :icon="'navigate_next'"
                                        tpos="left"
                                        size="big"
                                        color="ghost"
                                    />
                                    <mp3-player
                                        visualizer="music"
                                        tpos="left"
                                        :file="$env.services.storage.baseURL + '/assets/music-sample.mp3'"
                                        :text="'MUSIC SAMPLE'"
                                        size="big"
                                    />
                                    <visualizer name="music" />
                                </template>
                                <template #bg>
                                    <div class="icon" for="music">queue_music</div>
                                </template>
                            </AccordionItem>
                        </template>
                        <template #about>
                            <AccordionItem
                                for="about"
                                :selected="getSelected == 'about'"
                                :scene="getScene"
                                :class="{
                                    expanded: getFocus == 'about',
                                    collapsed: getFocus != 'about' && getFocus != '',
                                    landscape: getIsLanscape,
                                }"
                            >
                                <template #logo>
                                    <Icon code="about" />
                                </template>
                                <template #circles>
                                    <home-circles class="about">
                                        <template #white>
                                            <div class="name w">
                                                Henrich Platek<br /><small>voice & face agent</small>
                                            </div>
                                            <div class="inside">
                                                <a href="tel:00421905682931"><span class="icon">phone</span></a>
                                                <a href="mailto:henrich.platek@voicecasting.sk">
                                                    <span class="icon">mail_outline</span></a
                                                >
                                            </div>
                                        </template>
                                        <template #red>
                                            <div class="inside">
                                                <a href="tel:00421905756176"><span class="icon">phone</span></a>
                                                <a href="mailto:silvia@voicecasting.sk"
                                                    ><span class="icon">mail_outline</span></a
                                                >
                                            </div>
                                            <div class="name r">
                                                Silvia Balcová <br /><small>voice & face agent</small>
                                            </div>
                                        </template>
                                        <template #grey>
                                            <div class="inside">
                                                <a href="tel:00421903439368"><span class="icon">phone</span></a>
                                                <a href="mailto:peter.surovy@voicecasting.sk">
                                                    <span class="icon">mail_outline</span></a
                                                >
                                            </div>
                                            <div class="name g">
                                                Peter Surový <br /><small>voice & face admin</small>
                                            </div>
                                        </template>
                                    </home-circles>
                                </template>
                                <template #visualizer>
                                    <nav-button
                                        v-if="!getIsDetail"
                                        :link="'/about'"
                                        :text="'MORE'"
                                        :icon="'navigate_next'"
                                        tpos="left"
                                        size="big"
                                        color="ghost"
                                    />
                                </template>
                                <template #bg>
                                    <div class="icon" for="about">portrait</div>
                                </template>
                            </AccordionItem>
                        </template>
                    </accordion>
                </div>
                <div block="detail">
                    <div container="detail" type="vertical" align="left" valign="stretch" width="1">
                        <div block="menu">
                            <home-menu></home-menu>
                        </div>
                        <div block="content" width="1">
                            <div v-bar class="vb">
                                <div>
                                    <transition name="rightIn">
                                        <router-view view="detail" :scene="getScene"></router-view>
                                    </transition>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </container>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import Container from '@/mock/Container.vue';
import Accordion from '@/components/Home/Accordion.vue';
import AccordionItem from '@/components/Home/AccordionItem.vue';
import NavButton from '@/components/.global/NavButton.vue';
import Mp3Player from '@/components/.global/Mp3Player.vue';
import Icon from '@/components/Home/Icons.vue';
import HomeCircles from '@/components/Home/HomeCircles.vue';
import HomeMenu from '@/components/Home/HomeMenu.vue';
import Logo from '@/components/AppHeader/Logo.vue';
import VideoGalleryPlayer from '@/components/Profile/Video/Gallery/VideoGalleryPlayer.vue';

//import Velocity from 'velocity-animate';

export default {
    name: 'Profile',

    computed: {
        getSelected() {
            return this.$route.meta.content;
        },

        getFocus() {
            return this.focused;
        },

        getIsDetail() {
            return this.$route.path.length > 1;
        },

        getScene() {
            return this.$route.meta.scene;
        },

        getCaption() {
            return this.$route.meta.text;
        },

        getIsLanscape() {
            return window.matchMedia('(min-width: 768px)').matches;
        },

        ...mapGetters(['getIsLoggedIn', 'getAppStats']),
    },

    data() {
        return {
            focused: '',
            orientation: '',
        };
    },

    methods: {
        closeDetail() {
            this.$router.push({ path: '/' });
        },

        setFocus(event, orientation) {
            this.orientation = orientation;
            this.focused = event.currentTarget.getAttribute('block');
        },

        collapseAll(event) {
            this.focused = '';
        },

        playFaceCination() {
            this.setActorVideoPlaying({
                file: this.$env.services.storage.baseURL + '/assets/FACECINATION.mp4',
                controls: false,
                loop: true,
            });
        },

        ...mapActions(['openAuthPopup']),
        ...mapMutations(['setActorVideoPlaying']),
    },

    components: {
        VideoGalleryPlayer,
        Container,
        Accordion,
        AccordionItem,
        Mp3Player,
        NavButton,
        Icon,
        HomeCircles,
        HomeMenu,
        Logo,
    },
};
</script>
<style lang="less">
@import '~@variables';

[component='Home'] {
    width: 100%;
    height: 100%;

    // [component='MenuButton'] {
    //     position: fixed !important;
    // }

    .vb-dragger {
        @media (max-width: 979px) {
            display: none !important;
        }
    }

    .logo {
        // position: fixed;
        // top: 0px;
        // margin: 0;

        @media (min-width: 980px) and (min-height: 600px) {
            margin-left: -30px;
            top: 50px;
        }
    }

    &[template='page'] .bg {
        @media (min-width: 980px) {
            overflow: visible;
        }
    }

    .navigation {
        z-index: 600;
        left: 0;
        position: fixed;
        top: 0;
        width: 100%;
        height: 50px;
        // background: white;
        border-radius: 0 0 0 20px;

        .switcher {
            right: 120px;

            &.logged {
                right: 40px;
            }
        }

        @media (min-width: 980px) {
            display: none;
        }
        @media (max-height: 375px) {
            height: 30px;
        }
    }

    [view='detail'] {
        display: flex;
        flex-direction: column;

        @media (min-width: 520px) {
            flex-direction: row;
        }

        [block='subpage'] {
            width: 100%;
            left: 0;

            @media (min-width: 520px) {
                width: calc(100% - 170px);
                left: 170px;
                height: 100%;
            }
        }
    }

    [block='login'] {
        .flex-center;
        width: 100%;
        position: relative;

        button,
        .button {
            height: 50px;
            width: 100%;
            border-radius: 50px;
            margin: 0;

            @media (min-width: 768px) {
                display: none;
            }
        }
    }
}

// accordion

[component='Home'] [container='main'] {
    overflow: hidden;
    flex-direction: column;
    height: auto;
    // min-height: 100%;
    // min-height: 375px;

    @media (min-width: 980px) {
        padding: 50px 30px 30px 30px;
        flex-direction: row;
        height: 100%;
        border-radius: 20px;
        overflow: visible;

        &.hasDetail {
            box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 10%), 0 2px 2px 0 rgba(0, 0, 0, 14%),
                0 1px 15px 0 rgba(0, 0, 0, 15%) !important;
            overflow: hidden;
        }
    }
}

[block='accordion'] {
    left: 0;
    top: 0;
    height: calc(100% + 0px);
    width: 100%;
    transition: 1s;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    position: absolute;

    @media (min-width: 980px) {
        width: 100%;
        height: 100%;
        overflow: visible;
    }
}

[block='detail'] {
    overflow: hidden;
    .radiusMid;
    top: 0;
    left: 0;
    width: 100%;
    transition: 1s;

    @media (min-width: 980px) {
        position: absolute;
        right: 30px;
        width: 60%;
        height: 100%;
        left: auto;
        opacity: 0;
    }

    // @media (min-width: 768px) and (max-width: 980px) {
    // 	padding: 20px;
    // }

    [container='detail'] {
        height: 100%;
        transform: translateX(0%);
        min-height: calc(100vh - 530px);

        [block='menu'] {
            display: none;

            @media (min-width: 520px) {
                display: block;
            }
        }

        [block='content'] {
            width: 100%;
            height: 100%;
            overflow: hidden;

            @media (min-width: 980px) {
                background: linear-gradient(120deg, rgba(0, 0, 0, 0) 60%, #eaeaea);
                border-bottom-right-radius: 20px;
            }

            @media (max-width: 768px) {
                .vb {
                    position: static !important;
                }
            }
        }
    }
}

&[scene='list'] {
    // &[template='page'] .bg {
    // 	@media (min-width: 768px) and (max-width: 980px) {
    // 		padding-top: 50px;
    // 	}
    // }

    [block='accordion'] {
    }

    [block='detail'] {
        transform: translateY(100vh);

        @media (min-width: 980px) {
            left: calc(100% + 30px);
            transform: translateY(0vh);
            top: 0;
        }
    }
}

&[scene='detail'] {
    [block='accordion'] {
        width: 100%;
        height: 180px;

        @media (min-height: 480px) {
            height: 280px;
        }

        @media (min-height: 600px) {
            height: 330px;
        }

        @media (min-width: 980px) {
            width: 40%;
            height: 100%;
        }

        [component='Accordion'] > [block] {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            &.selected {
                z-index: 80;
            }
        }
    }

    [block='detail'] {
        left: 0px;
        margin-top: 200px;
        padding: 0 10px;

        @media (min-height: 480px) {
            margin-top: 310px;
        }

        @media (min-height: 600px) {
            margin-top: 360px;
        }

        @media (min-width: 980px) {
            margin-top: 0;
            left: 40%;
            padding: 0 0 0 30px;
            opacity: 1;
        }
    }

    [block='login'] {
        display: none;
    }
}

&[scene='subpage'] {
    [block='accordion'] {
        height: 130px;

        @media (min-width: 980px) {
            width: 130px;
            height: 100%;
        }
    }

    [block='detail'] {
        margin-top: 160px;

        @media (min-width: 980px) {
            margin-top: 0px;
            left: 130px;
            padding-left: 30px;
            width: calc(100% - 130px);
        }

        [container='detail'] {
            min-height: calc(100vh - 240px);
        }
    }

    [block='login'] {
        display: none;
    }
}
</style>
